var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { title: "Cash Flow Report" } },
        [
          _c("CashFlowFilterForm", {
            attrs: { loading: _vm.loading.find },
            on: { submit: _vm.handleFind }
          }),
          _c(
            "a-row",
            [
              _c("a-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticClass: "cash-flow-report-content" },
                  [
                    _c("CashFlowReportTable", {
                      attrs: {
                        "data-source": _vm.reportData
                          ? _vm.reportData.columns
                          : [],
                        loading: _vm.loading.find,
                        "show-total": _vm.showTotal
                      },
                      on: { "detail-click": _vm.handleDetailClick }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("a-divider"),
          _c(
            "a-row",
            { attrs: { type: "flex", justify: "end" } },
            [
              _c(
                "a-dropdown",
                { attrs: { disabled: _vm.reportData === null } },
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1", on: { click: _vm.handleDownloadSummary } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("lbl_download_summary")) + " "
                          )
                        ]
                      ),
                      _c(
                        "a-menu-item",
                        { key: "2", on: { click: _vm.handleDownloadDetail } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("lbl_download_detail")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("a-button", { attrs: { type: "primary", icon: "down" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("lbl_download_report")) + " ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("CashFlowReportDetailModal", {
        attrs: {
          visible: _vm.detailModal.visible,
          "category-id": _vm.detailModal.categoryId,
          "date-from": _vm.detailModal.dateFrom,
          "date-to": _vm.detailModal.dateTo
        },
        on: { cancel: _vm.handleDetailModalClose }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }